import React, { useRef, useState, useEffect } from 'react';
import styles from 'wienenergiedesignsystem/components/Video/Video.module.scss';
import FontAwesomeProIcon from 'wienenergiedesignsystem/components/FontAwesome/FontAwesomeProIcon';
import { Button } from 'reakit/Button';

var Video = function Video(_ref) {
  var poster = _ref.poster,
      video = _ref.video,
      track = _ref.track,
      autoPlay = _ref.autoPlay,
      loop = _ref.loop,
      muted = _ref.muted,
      controls = _ref.controls,
      className = _ref.className,
      preload = _ref.preload,
      title = _ref.title;
  var videoParentRef = useRef(null);

  var _useState = useState(null),
      videoState = _useState[0],
      setVideoState = _useState[1];

  var handlePlayClick = function handlePlayClick() {
    if (!videoParentRef.current && !videoParentRef.current.children[0]) {
      return;
    }

    var player = videoParentRef.current.children[0];
    player.play();
  };

  useEffect(function () {
    if (!videoParentRef.current && !videoParentRef.current.children[0]) {
      return;
    } // obtain reference to the video element


    var player = videoParentRef.current.children[0];
    player.classList.add(className);
    player.controls = controls;
    player.playsinline = true;
    player.autoplay = autoPlay;
    player.loop = loop;

    if (muted) {
      player.muted = muted;
      player.setAttribute('muted', ''); // leave no stones unturned :)
    }

    if (preload) {
      player.setAttribute('preload', preload);
    }

    if (poster) {
      player.poster = poster;
    }

    if (title) {
      player.setAttribute('title', title);
    }

    setTimeout(function () {
      player.addEventListener('play', function () {
        setVideoState('play');
      }, false);

      if (autoPlay) {
        player.play();
      }
    }, 0);
  }, []);

  if (!video) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, !autoPlay && videoState !== 'play' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handlePlayClick,
    as: "div",
    className: styles.overlay,
    "aria-label": "Video abspielen"
  }, /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    className: styles.actionIcon,
    icon: "play-circle",
    role: "presentation"
  }))), /*#__PURE__*/React.createElement("div", {
    ref: videoParentRef,
    dangerouslySetInnerHTML: {
      __html: "<video playsinline>\n        <source src=\"" + video.src + "\" type=\"video/mp4\" />\n        " + (track ? "<track src=\"" + track + "\" kind=\"subtitles\" srcLang=\"de\" label=\"Deutsch\" />" : '') + "\n        Your browser does not support the video tag.\n      </video>"
    }
  }));
};

export { Video as default };